import { useMediaQuery } from 'react-responsive'






export const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 881 })
    return isDesktop ? children : null
}

export const UnderDesktop = ({ children }) => {
    const isDesktop = useMediaQuery({ maxWidth: 1020 })
    return isDesktop ? children : null
}



export const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 880 })
    return isTablet ? children : null
}
export const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 })
    return isMobile ? children : null
}


export default Desktop;


